import React, { Fragment, useEffect, useState, useContext } from 'react'
import { Link } from 'react-router-dom'
import styled, {css} from 'styled-components';
import { MetaContext } from "../context";
import { Button, Text, Line, CSSpreloader, MIcon, MobHideSpan } from './Uikit';
import { PrShop } from './PrShop';
import { getDataById, calculateTotal } from './Utilities';
import { Svg } from './Uikit_Svg';


export function AddToCart({
  deleteHandler = ()=> void(0),
  handleCheckout = ()=> void(0)
}) {
  const context = useContext(MetaContext);

// let cart = [{variantId: '', quantity: parseInt(1, 10)}];

  const [pressed, setPressed] = useState(false)

  const convertToCart = () =>  {

    if (!context.data.products) return



    let cart = [];
    let codes = [];
    context.handles.getStack().forEach(oneItm => {
      codes.push(getDataById(context, oneItm['id'])["code"])
    })
    codes.forEach(oneCode => {
      let product = context.data.products.filter(onePr => {
        // console.log('onePr.variants[0][\'sku\'] = ', onePr.variants[0]['sku']);
        if (onePr.variants[0]['sku'] === oneCode) return true;
      });
      if (product.length) {
        cart.push({
          variantId: product[0]['variants'][0]['id'],
          quantity: 1
        })
        console.log('ADDED = ', oneCode);
        // context.handles.addVariantToCart(product[0]['variants'][0]['id'], 1)
      } else {
        console.log('NOT FOUND = ', oneCode);
      }
    })

    // debugger;
    console.log('cart = ', cart);
    context.handles.addArrayToCart(cart)

  }

  return (
    <CSSaddToCart0>


{/* {context && context.state.checkout && context.data.products[1] && <PrShop
addVariantToCart={context.handles.addVariantToCart}
client={context.data.client}
// key={product.id.toString()}
product={context.data.products[1]}
/>} */}

      <Line>
        <Text bold xlg>€&thinsp;{calculateTotal(context)}</Text>
      </Line>

      <Button
        disabled={pressed || !(context.data.supplements.length && context.handles.getStack() && context.data.products)}
        onClick={() => {
          setPressed(true)
          convertToCart();
          handleCheckout();
        }}>{pressed && <CSSpreloader/>}
        Order stack</Button>

<br/>
<br/>

<Button
secondary
// flat
sm
>
            <MIcon size={14} left>link</MIcon>
            <MobHideSpan>Copy stack link</MobHideSpan>
          </Button>

<br/>
<br/>
          <Button
          secondary
            // flat
            sm
            onClick={() => {
              deleteHandler();
            }}
          >
            <MIcon left size={14}>delete</MIcon>
            <MobHideSpan>Delete stack</MobHideSpan>
          </Button>

    </CSSaddToCart0>
  )
}

const CSSaddToCart0 = styled.div`
  padding-bottom: 8em;
`
